import { useQuery } from '@tanstack/react-query';

import { withGlobalError } from '@/react-tools/react-query';
import axios, { parseAxiosError } from '@/portainer/services/axios';

import { PolicyId, TypedPolicy } from '../types';

import { queryKeys } from './query-keys';

export function usePolicy(id: PolicyId) {
  return useQuery({
    queryKey: queryKeys.detail(id),
    queryFn: () => getPolicy(id),
    // falsy policyIDs, including 0, disable the query
    enabled: !!id,
    ...withGlobalError('Unable to load policy'),
  });
}

async function getPolicy(id: PolicyId): Promise<TypedPolicy<unknown>> {
  try {
    const { data } = await axios.get<TypedPolicy<unknown>>(`/policies/${id}`);
    return data;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to retrieve policy');
  }
}
